import { action, computed, observable, reaction, makeObservable } from 'mobx';
import { logger } from '../../lib/helpers/misc/logger';
import { authenticationLoaders } from '../loaders/authenticationLoaders';
import { User } from '../models/user';
import { UserStatus } from '../models/user-status';
import { userStatusBuilder } from '../utils/userStatusBuilder';

const builder = userStatusBuilder;

class UserStatusService {
    @observable.ref
    private _status: UserStatus;

    private whoami: Promise<UserStatus> | null;

    constructor() {
        makeObservable(this);
        this._status = builder.unknown();

        this.whoami = null;

        this.setup();
    }

    private setup() {
    }

    @computed
    get status(): UserStatus {
        return this._status;
    }

    @computed
    get user(): User | null {
        if (this._status.isLoggedIn)
            return null;
        return this._status.user;
    }

    @action
    setLoggedIn = (user: User) => {
        this._status = builder.loggedIn(user);
    };

    @action
    setLoggedOut = () => {
        authenticationLoaders.signOut();
        this._status = builder.loggedOut();
        const intercom = (window as any).Intercom;
        intercom('shutdown');
    };

    @action
    setServerUnreachable = () => {
        this._status = builder.serverUnreachable();
    };

    refreshWhoAmI() {
        if (this.whoami !== null)
            return;
        this.whoami = authenticationLoaders.whoAmI();
        this.whoami.then(status => this.acceptWhoAmIResponse(status));
    }

    @action
    private acceptWhoAmIResponse(status: UserStatus) {
        this.whoami = null;
        this._status = status;
        (window as any).Tilzone.CurrentUserId = status.user?.Id;
        const user = status.user;
        const intercom = (window as any).Intercom;
        // Intercom
        if (user && intercom) {
            intercom("boot", {
                api_base: "https://api-iam.intercom.io",
                app_id: "b8w4ohh8",
                name: user.FirstName + ' ' + user.LastName, // Full name
                email: user.Email, // Email address
                created_at: user.CreationDateTime, // Signup date as a Unix timestamp
                user_id: user.Id,
                user_hash: user.UserHash
            });
        }
    }
}

export const userStatusService = new UserStatusService();
